import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import HeaderFirst from 'utils/HeaderFirst';
import '../ventes/client.css';
import { useGetCreanceByIdQuery } from 'actions/creances/queries';
import { getUser } from 'redux/features/userSliceWithTokenValidation';
import { useSelector } from 'react-redux';
import { formatDate, formatTime } from 'utils/dateHelpers';

function formatSourcePaiement(source_paiement) {
  return source_paiement === 'orange_money'
    ? 'Orange Money'
    : source_paiement === 'wave'
      ? 'Wave'
      : source_paiement === 'banque'
        ? 'Banque'
        : source_paiement === 'caisse'
          ? 'Caisse'
          : 'Autre';
}

const DetailCreancePage = () => {
  const { id, clientID: dossier_id } = useParams();
  const navigate = useNavigate();
  const userStatus = useSelector(getUser);

  const { data: creanceDetail, isLoading, error } = useGetCreanceByIdQuery({
    id,
    dossier_id,
  });

  const creance = Array.isArray(creanceDetail) ? creanceDetail[0] : creanceDetail;

  if (isLoading) return <div>Chargement des détails de la créance...</div>;
  if (error) return <div>Une erreur est survenue lors du chargement de la créance.</div>;
  if (!creance) return <div>Créance non trouvée.</div>;

  const statusColor = creance.archived ? '#991B1B' : '#009688';

  const formattedCreance = {
    'Date de la créance': formatDate(creance.updated_at),
    'Heure de la créance': formatTime(creance.updated_at),
    Intitulé: creance.intitule,
    Client: creance.client_details?.nom || 'Information non disponible',
    Statut: creance.archived ? 'Archivée' : 'Active',
    'Montant total': new Intl.NumberFormat('fr-FR').format(Number.isFinite(Number(creance.montant_total)) ? Number(creance.montant_total) : (Number.isFinite(Number(creance.prix)) ? Number(creance.prix) : 0)) + ' FCFA',
    'Montant payé': new Intl.NumberFormat('fr-FR').format(Number.isFinite(Number(creance.montant_paye)) ? Number(creance.montant_paye) : 0) + ' FCFA',
    'Solde restant': new Intl.NumberFormat('fr-FR').format(Number.isFinite(Number(creance.reste_a_payer)) ? Number(creance.reste_a_payer) : (Number.isFinite(Number(creance.montant_restant)) ? Number(creance.montant_restant) : 0)) + ' FCFA',
    'Statut paiement': creance.statut_paiement,
    'Moyen de paiement': formatSourcePaiement(creance.source_paiement),
    'Créance créée par': userStatus?.first_name || 'Utilisateur inconnu',
    'Taxes': creance.taxes + ' %',
    'Remise': creance.remise + ' %',
    'Description': creance.description || 'Aucune description',
  };

  const productDetails = creance.produits_associes?.map((prod, index) => ({
    key: index,
    Produit: prod.produit,
    Quantité: prod.quantite,
    'Prix unitaire': new Intl.NumberFormat('fr-FR').format(prod.prix) + ' FCFA',
  })) || [];

  return (
    <div
      className="transaction-page-details"
      style={{
        backgroundColor: 'white',
        minHeight: '500px',
        borderRadius: '20px',
        padding: '15px',
        fontFamily: 'Montserrat',
      }}
    >
      <div className="d-flex align-items-center">
        <HeaderFirst
          nom={
            <div>
              <h4 className="titre-dossier">
                Créance nº: {creance?.id}
              </h4>
              <h6 className="fw-bold" style={{ color: statusColor }}>
                Statut {creance.archived ? 'Archivée' : 'Active'}
              </h6>
            </div>
          }
          description={<div>Voici les détails de la créance.</div>}
        />
      </div>

      <div
        style={{
          padding: '15px',
          margin: '20px auto',
          display: 'grid',
          gridTemplateColumns: '1fr 1fr 1fr',
          gridGap: '30px',
        }}
      >
        {Object.entries(formattedCreance).map(([key, value]) => (
          <div
            key={key}
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '10px',
              alignItems: 'start',
              marginBottom: '10px',
            }}
          >
            <span style={{ fontWeight: 'bold' }}>{key}</span>
            <span>{value}</span>
          </div>
        ))}
      </div>

      {productDetails.length > 0 && (
        <div style={{ padding: '15px' }}>
          <strong>Produits Associés:</strong>
          <ul>
            {productDetails.map((detail) => (
              <li key={detail.key}>
                Produit: <strong>{detail.Produit}</strong>, Quantité:{' '}
                <strong>{detail.Quantité}</strong>, Prix unitaire:{' '}
                <strong>{detail['Prix unitaire']}</strong>
              </li>
            ))}
          </ul>
        </div>
      )}

      <div className="d-flex flex-column gap-2" style={{ padding: '15px' }}>
        <div className="d-flex justify-content-end gap-2">
          <button
            style={{
              backgroundColor: '#6c757d',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              padding: '10px 20px',
              cursor: 'pointer',
            }}
            onClick={() => navigate(-1)}
          >
            Retour
          </button>
        </div>
      </div>
    </div>
  );
};

export default DetailCreancePage;
